import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { SERVICES, WHATSAPP_URL } from "../data/site";

export const Services = () => (
  <section
    id="servicos"
    data-testid="services-section"
    className="relative bg-[#0a0a0a] py-20 md:py-28"
  >
    <div className="max-w-[1400px] mx-auto px-4 md:px-10">
      <Reveal className="mb-12 md:mb-16">
        <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
          / O que fazemos
        </span>
        <h2 className="mt-4 font-display font-bold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] max-w-3xl">
          Serviços de Guincho e Reboque
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <motion.a
                data-testid={`service-card-${i}`}
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -6 }}
                className="group relative flex flex-col h-full bg-[#121212] border border-white/[0.08] p-8 overflow-hidden transition-colors duration-300 hover:border-[#e60000] hover:bg-[#1a1a1a]"
              >
                <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-[#e60000]/0 group-hover:bg-[#e60000]/10 blur-2xl transition-colors duration-500" />
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 flex items-center justify-center border border-white/10 bg-[#050505] text-[#e60000] group-hover:bg-[#e60000] group-hover:text-white transition-colors duration-300">
                    <Icon size={26} />
                  </div>
                  <ArrowUpRight
                    size={22}
                    className="text-neutral-600 group-hover:text-[#e60000] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                  />
                </div>
                <h3 className="mt-6 font-display font-semibold text-white text-xl md:text-2xl leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-neutral-400 text-sm leading-relaxed">
                  {s.desc}
                </p>
                <span className="mt-6 font-mono-tech text-[11px] tracking-widest text-neutral-500 uppercase">
                  0{i + 1} — FS Guinchos
                </span>
              </motion.a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
